import {useEffect, useRef, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useLazyQuery, useMutation, NetworkStatus} from '@apollo/client'
import {v4 as uuidv4} from 'uuid'
import Select from 'react-select'
import moment from 'moment'
import {useFormik} from 'formik'
import {toast} from 'react-toastify'
import * as Yup from 'yup'

import {BreadcrumbJeisat} from '../../components/BreadcrumbJeisat'
import {Alert, Button, Card, Col, Collapse, Form, InputGroup, Row, Table} from 'react-bootstrap'
import {InputCurrency} from '../../components/InputCurrency'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import type {
  ClientListEdge,
  EdgeVolcos,
  IResCanterasVentas,
  IResClientsVentas,
  IResProductsVentas,
  IResVolcosDispatch,
  SaleSetEdge,
  SaleproductthroughSetEdge,
} from '../../graphql/types/ventasType'
import {Spinner} from '../../components/Spinner'
import {IResDataToFrom, getFormParse, parseId, parsePrice} from '../../helpers'
import {
  GET_CANTERAS_CREATE_DISPATCH,
  GET_CLIENTS_CREATE_DISPATCH,
  GET_NAMTRIK_FORM,
  GET_PRODUCTS_CREATE_DISPATCH,
  GET_VOLCOS_CREATE_DISPATCH,
} from '../../graphql/queries/getDespachos'
import {
  IDataGetNamtrikForm,
  INamtrikDataForm,
  IResCreateDispatch,
} from '../../graphql/types/despachoTypes'
import {NamtrikForm} from '../../components/NamtrikForm'
import {CREATE_DISPATCH} from '../../graphql/mutations/dispatchMutations'
import {IInputMutation, useDispatchesStore} from '../../store/dipatches'
import {STORAGE_NAMES} from '../../helpers/consts'
import {useGetUser} from '../../hooks/useGetUser'
import {AlertDispatchNoSales} from '../../components/addDispatch/AlertDispatchNoSales'

const validationSchema = Yup.object().shape({
  client: Yup.string().required('Cliente es obligatorio'),
  quarry: Yup.string().required('Cantera es obligatoria'),
  // product: Yup.string().required('Se requiere un producto'),
  // quantityDispatch: Yup.number()
  //   .min(1, 'Debe ser mayor o igual a 1')
  //   .required('La cantidad es obligatoria'),
  plate: Yup.string().required('La placa es obligatoria'),
  observations: Yup.string(),
})

/* interface IProductsInfo {
  name: string
  quantity: number
  id: string
} */

interface ISelectVolco {
  value: string
  label: string
  size: string
}
interface ISelect {
  value: string
  label: string
}

interface IInput {
  uuid: any
  plate: string
  departureTime: string
  quantityDispatch: string
  client: string
  quarry: string
  sale: string
  product: string
  observations: string
  delivery?: {
    date: string
    totalTravel: string
    fromLocation: string
    untilLocation: string
    responsible: string
  }
  form?: {
    forms: IResDataToFrom[]
  }
  invoiceId: string | number
}
/* interface ISelectPros {
  value: string
  label: string
  isDisabled?: boolean
} */
const ERRORS_FETCH = {
  NETWORK_ERROR: 'Failed to fetch',
}

export const AddDispatchPage = () => {
  const {user} = useGetUser()
  const dateStorage = localStorage.getItem(STORAGE_NAMES.DATE)
  const [gqlCreateDispatch, {data: dataCreate, loading: loadingCreate, error: errorCreate}] =
    useMutation<IResCreateDispatch>(CREATE_DISPATCH)
  const [
    gqlGetClients,
    {
      data: dataClients,
      loading: loadingClients,
      error: errorClients,
      networkStatus: networkStatusClients,
    },
  ] = useLazyQuery<IResClientsVentas>(GET_CLIENTS_CREATE_DISPATCH, {fetchPolicy: 'no-cache'})
  const [
    gqlGetCanteras,
    {
      data: dataCanteras,
      loading: loadingCanteras,
      networkStatus: networkStatusCanteras,
      error: errorCanteras,
    },
  ] = useLazyQuery<IResCanterasVentas>(GET_CANTERAS_CREATE_DISPATCH)
  const [
    gqlGetVolcos,
    {
      data: dataVolcos,
      loading: loadingVolcos,
      networkStatus: networkStatusVolcos,
      error: errorVolcos,
    },
  ] = useLazyQuery<IResVolcosDispatch>(GET_VOLCOS_CREATE_DISPATCH)
  const [
    gqlGetProducts,
    {
      data: dataProducts,
      loading: loadingProducts,
      networkStatus: networkStatusProducts,
      error: errorProducts,
    },
  ] = useLazyQuery<IResProductsVentas>(GET_PRODUCTS_CREATE_DISPATCH)
  const [
    gqlGetNamtrikForm,
    {
      data: dataNamtrikForm,
      loading: loadingNamtrikForm,
      error: errorNamtrikForm,
      networkStatus: networkStatusNamtrikForm,
    },
  ] = useLazyQuery<IDataGetNamtrikForm>(GET_NAMTRIK_FORM)

  const totalArrClients = useRef<ClientListEdge[]>([])

  const totalArrVolcos = useRef<EdgeVolcos[]>([])

  const addDispatch = useDispatchesStore((s) => s.inc)
  const dipatchesStore = useDispatchesStore((s) => s.dipatches)

  const navigate = useNavigate()

  const [clientSelects, setClientSelects] = useState<ISelect[]>([])
  const [allClientsData, setAllClientsData] = useState<ClientListEdge[]>([])
  const [canterasSelect, setCanterasSelect] = useState<ISelect[]>([])
  const [volcosSelect, setVolcosSelect] = useState<ISelectVolco[]>([])
  const [ventasSelect, setVentasSelect] = useState<SaleSetEdge[]>([])
  const [productsSelect, setProductsSelect] = useState<SaleproductthroughSetEdge[]>([])
  const [productsOnlyPos, setProductsOnlyPos] = useState<SaleproductthroughSetEdge[]>([])

  const [keySelectPlaque, setKeySelectPlaque] = useState(Date.now().toString())

  const [errorProductsForm] = useState<string | null>(null)
  const [selectOneClient, setSelectOneClient] = useState<null | {
    value: string
    label: string
    isDisabled?: boolean
  }>(null)
  const [idVentaSelect, setIdVentaSelect] = useState('')

  const [dataLoad, setDataLoad] = useState(0)

  const [filterId, setFilterId] = useState('')
  const [filterPrice, setFilterPrice] = useState('')
  const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0])

  const [isTransport, setIsTransport] = useState(false)
  const [namtrikForm, setNamtrikForm] = useState<INamtrikDataForm[] | null>(null)
  const [formDynamicValues, setFormDynamicValues] = useState<IResDataToFrom[] | null>(null)

  const [isPostpay, setIsPostpay] = useState(false)

  const [volcoSizeAllowed, setVolcoSizeAllowed] = useState<null | string>(null)
  const [errorQuatity, setErrorQuatity] = useState<null | string>(null)
  const [infoGlobalInput, setInfoGlobalInput] = useState<IInputMutation | null>(null)

  const [totDispatches, setTotDispatches] = useState(0)

  const [loadingRefetch /* setLoadingRefetch */] = useState(false)

  const [productsToSend, setProductsToSend] = useState<{product: string; quantity: string}[]>([])

  const formik = useFormik({
    initialValues: {
      plate: '',
      departureTime: '',
      quantityDispatch: '',
      client: '',
      quarry: '',
      sale: '',
      product: '',
      observations: '',
      delivery: {
        date: '',
        totalTravel: '',
        fromLocation: '',
        untilLocation: '',
        responsible: '',
      },
    },
    validationSchema,
    onSubmit(values) {
      const input: IInput = {
        ...values,
        uuid: uuidv4(),
        sale: idVentaSelect,
        invoiceId: totDispatches + 1,
      }
      if (!isTransport) {
        delete input.delivery
      }
      if (formDynamicValues) {
        input.form = {
          forms: formDynamicValues,
        }
      }
      const idClient = input.client.split('***')[0]
      // const idProduct = input.product.split('***')[0]
      const inputSend = {
        ...input,
        sale: parseId(input.sale),
        quarry: parseId(input.quarry),
        departureTime: new Date(input.departureTime).toISOString(),
        products: productsToSend.map((inf) => ({
          quantityDispatch: Number(inf.quantity),
          product: inf.product,
        })),
        quantityDispatch: undefined,
      }
      setInfoGlobalInput(inputSend)
      console.log('totDispatches + 1', totDispatches + 1)
      console.log('productsToSend', productsToSend)
      console.log('inputSend', inputSend)
      // if (totDispatches || idClient) return
      gqlCreateDispatch({
        variables: {
          input: {
            ...inputSend,
            client: parseId(idClient),
            products: inputSend.products.map((pro) => ({
              ...pro,
              product: parseId(pro.product.split('***')[0]),
            })),
            product: undefined,
          },
        },
      })
    },
  })

  useEffect(() => {
    console.log('dateStorage', dateStorage)
    if (dateStorage) {
      const datePass = new Date(dateStorage).getTime()
      const now = new Date().getTime()
      const diff = now - datePass
      const diffMin = diff / (1000 * 60)
      if (diffMin < 30) {
        // clientes
        const dataStrClients = localStorage.getItem(STORAGE_NAMES.CLIENTS)
        if (!dataStrClients || !user) return
        const dataArrClients = JSON.parse(dataStrClients) as ClientListEdge[]
        console.log('dataArrClients', dataArrClients)
        setClientSelects(
          dataArrClients
            .filter(
              ({node}) =>
                node.saleSet.edges.length > 0 ||
                node.postpaidSales ||
                Number(user.tokenAuth.settings.DISPATCH_WITHOUT_SALES)
            )
            .map(({node}) => ({
              value: `${node.id}***${node.name}`,
              label: `${node.name}`,
            }))
        )
        setAllClientsData(dataArrClients)
        // canteras
        const dataStrCanteras = localStorage.getItem(STORAGE_NAMES.CANTERAS)
        if (!dataStrCanteras) return
        const dataArrCanteras = JSON.parse(dataStrCanteras) as ISelect[]
        setCanterasSelect(dataArrCanteras)
        // productos
        const dataStrProds = localStorage.getItem(STORAGE_NAMES.PRODUCTS)
        if (!dataStrProds) return
        const dataArrProds = JSON.parse(dataStrProds) as SaleproductthroughSetEdge[]
        console.log('dataArrProds', dataArrProds)
        const arr = dataArrProds.map((inf) => ({
          node: {...inf.node, units: inf.node.units || Infinity},
        }))
        setProductsSelect(arr)
        setProductsOnlyPos(arr)
        // namtrik forms
        const strForm = localStorage.getItem(STORAGE_NAMES.NAMTRIK_FORM)
        if (!strForm) return
        const dataArrForm = JSON.parse(strForm) as string[]
        setNamtrikForm(dataArrForm.map((strForm) => JSON.parse(strForm) as INamtrikDataForm))
        // volcos
        const dataStrVolcos = localStorage.getItem(STORAGE_NAMES.VOLCOS)
        if (!dataStrVolcos) return
        const dataArrVolcos = JSON.parse(dataStrVolcos) as ISelectVolco[]
        setVolcosSelect(dataArrVolcos)
        return
      }
    }
    gqlGetClients({
      variables: {
        statusSale: 'ABIERTA',
      },
    })
    gqlGetCanteras()
    gqlGetVolcos()
    gqlGetProducts()
    gqlGetNamtrikForm({
      variables: {
        codename: 'CLIENTE',
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateStorage])

  useEffect(() => {
    if (!dataClients) return
    if (!user) return
    if (dataClients.clientList?.edges?.length > 0) {
      totalArrClients.current = [...totalArrClients.current, ...dataClients.clientList.edges]
      if (dataClients?.clientList?.pageInfo.hasNextPage) {
        console.log('dataClients', dataClients)
        gqlGetClients({
          variables: {
            statusSale: 'ABIERTA',
            after: dataClients.clientList.pageInfo.endCursor,
          },
        })
        return
      }
      setClientSelects(
        totalArrClients.current
          .filter(
            ({node}) =>
              node.saleSet.edges.length > 0 ||
              node.postpaidSales ||
              Number(user.tokenAuth.settings.DISPATCH_WITHOUT_SALES)
          )
          .map(({node}) => ({
            value: `${node.id}***${node.name}`,
            label: `${node.name}`,
          }))
      )
      setAllClientsData(totalArrClients.current)
      localStorage.setItem(STORAGE_NAMES.CLIENTS, JSON.stringify(totalArrClients.current))
      setDataLoad((pre) => pre + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataClients])
  useEffect(() => {
    if (!dataCanteras) return
    if (dataCanteras.quarryList?.edges?.length > 0) {
      const arr = dataCanteras.quarryList.edges.map(({node}) => ({
        value: node.id,
        label: node.name,
      }))
      setCanterasSelect(arr)
      localStorage.setItem(STORAGE_NAMES.CANTERAS, JSON.stringify(arr))
      setDataLoad((pre) => pre + 1)
    }
  }, [dataCanteras])

  useEffect(() => {
    if (!errorClients) return
    if (errorClients.message === ERRORS_FETCH.NETWORK_ERROR) {
      if (networkStatusClients === NetworkStatus.error) {
        const dataStr = localStorage.getItem(STORAGE_NAMES.CLIENTS)
        if (!dataStr) return
        if (!user) return
        const dataArr = JSON.parse(dataStr) as ClientListEdge[]
        setClientSelects(
          dataArr
            .filter(
              ({node}) =>
                node.saleSet.edges.length > 0 ||
                node.postpaidSales ||
                Number(user.tokenAuth.settings.DISPATCH_WITHOUT_SALES)
            )
            .map(({node}) => ({
              value: `${node.id}***${node.name}`,
              label: `${node.name}`,
            }))
        )
        setAllClientsData(dataArr)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorClients, networkStatusClients])
  useEffect(() => {
    if (!errorCanteras) return
    if (errorCanteras.message === ERRORS_FETCH.NETWORK_ERROR) {
      if (networkStatusCanteras === NetworkStatus.error) {
        const dataStr = localStorage.getItem(STORAGE_NAMES.CANTERAS)
        if (!dataStr) return
        const dataArr = JSON.parse(dataStr) as ISelect[]
        setCanterasSelect(dataArr)
      }
    }
  }, [errorCanteras, networkStatusCanteras])

  useEffect(() => {
    if (!dataVolcos) return
    console.log('entre')

    if (dataVolcos.transportList?.edges?.length > 0) {
      totalArrVolcos.current = [...totalArrVolcos.current, ...dataVolcos.transportList.edges]
      if (dataVolcos?.transportList?.pageInfo.hasNextPage) {
        console.log('dataVolcos', dataVolcos)
        gqlGetVolcos({
          variables: {
            after: dataVolcos.transportList.pageInfo.endCursor,
          },
          fetchPolicy: 'no-cache',
        })
        return
      }
      const arr = totalArrVolcos.current.map(({node}) => ({
        value: node.plate,
        label: node.plate,
        size: node.sizeVolco,
      }))
      setVolcosSelect(arr)
      localStorage.setItem(STORAGE_NAMES.VOLCOS, JSON.stringify(arr))
      setDataLoad((pre) => pre + 1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataVolcos])
  useEffect(() => {
    if (!errorVolcos) return
    if (errorVolcos.message === ERRORS_FETCH.NETWORK_ERROR) {
      if (networkStatusVolcos === NetworkStatus.error) {
        const dataStr = localStorage.getItem(STORAGE_NAMES.VOLCOS)
        if (!dataStr) return
        const dataArr = JSON.parse(dataStr) as ISelectVolco[]
        setVolcosSelect(dataArr)
      }
    }
  }, [errorVolcos, networkStatusVolcos])
  useEffect(() => {
    if (!dataProducts) return
    if (dataProducts.productList?.edges?.length > 0) {
      const arr = dataProducts.productList.edges.map(({node}) => ({
        node: {
          id: node.id,
          units: Infinity,
          product: {
            id: node.id,
            unitType: node.unitType!,
            name: node.name,
            unitPrice: node.unitPrice,
            promotion: node.promotion,
          },
        },
      }))
      // setVolcosSelect(arr)
      console.log('arr', arr)
      localStorage.setItem(STORAGE_NAMES.PRODUCTS, JSON.stringify(arr))
      setProductsOnlyPos(arr)
      setDataLoad((pre) => pre + 1)
    }
  }, [dataProducts])
  useEffect(() => {
    if (!errorProducts) return
    if (errorProducts.message === ERRORS_FETCH.NETWORK_ERROR) {
      if (networkStatusProducts === NetworkStatus.error) {
        const dataStr = localStorage.getItem(STORAGE_NAMES.PRODUCTS)
        if (!dataStr) return
        const dataArr = JSON.parse(dataStr) as SaleproductthroughSetEdge[]
        setProductsOnlyPos(dataArr)
        // setVolcosSelect(dataArr)
      }
    }
  }, [errorProducts, networkStatusProducts])

  /* useEffect(() => {
    if (formik.isSubmitting) {
      setErrorProductsForm((pre) => (productsInfo.length > 0 ? null : pre))
    }
  }, [formik.isSubmitting, productsInfo]) */

  useEffect(() => {
    if (!errorCreate) return
    if (errorCreate.message === ERRORS_FETCH.NETWORK_ERROR && infoGlobalInput) {
      addDispatch(infoGlobalInput)
      toast.warning('Este despacho será enviado cuando tengas conexión a internet', {
        autoClose: false,
      })
      setVentasSelect([])
      formik.resetForm()
      setSelectOneClient(null)
      setVolcoSizeAllowed(null)
      setProductsToSend([])
      setKeySelectPlaque(Date.now().toString())
    } else {
      toast.error('Error: ' + errorCreate.message)
      setInfoGlobalInput(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorCreate])
  useEffect(() => {
    if (!dataCreate) return
    if (dataCreate.dispatchCreate.success) {
      toast.success('Despacho creado con éxito')
      formik.resetForm()
      // setLoadingRefetch(true)
      navigate(`/despacho/${parseId(dataCreate.dispatchCreate.dispatch.id)}`)
      /* gqlGetClients({
        variables: {
          statusSale: 'ABIERTA',
        },
      }).then(() => {
        setLoadingRefetch(false)
      }) */
    } else if (dataCreate.dispatchCreate.errors) {
      toast.error('Error: ' + dataCreate.dispatchCreate.errors.message)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCreate])

  useEffect(() => {
    if (!errorNamtrikForm) return
    toast.error('Error: ' + errorNamtrikForm.message)
    if (errorNamtrikForm.message === ERRORS_FETCH.NETWORK_ERROR) {
      if (networkStatusNamtrikForm === NetworkStatus.error) {
        const str = localStorage.getItem(STORAGE_NAMES.NAMTRIK_FORM)
        if (!str) return
        const dataArr = JSON.parse(str) as string[]
        setNamtrikForm(dataArr.map((strForm) => JSON.parse(strForm) as INamtrikDataForm))
      }
    }
  }, [errorNamtrikForm, networkStatusNamtrikForm])

  useEffect(() => {
    if (!dataNamtrikForm) return
    if (dataNamtrikForm.getEntityForms.length === 0) return
    setNamtrikForm(dataNamtrikForm.getEntityForms.map((str) => JSON.parse(str) as INamtrikDataForm))
    localStorage.setItem(STORAGE_NAMES.NAMTRIK_FORM, JSON.stringify(dataNamtrikForm.getEntityForms))
    setDataLoad((pre) => pre + 1)
  }, [dataNamtrikForm])

  useEffect(() => {
    if (dataLoad === 5) {
      localStorage.setItem(STORAGE_NAMES.DATE, new Date().toISOString())
      setDataLoad(0)
    }
  }, [dataLoad])

  useEffect(() => {
    if (!selectOneClient) {
      setVentasSelect([])
      setIsPostpay(false)
      return
    }

    const idSelectClient = selectOneClient.value.split('***')[0]

    const find = allClientsData.find(({node}) => node.id === idSelectClient)
    if (!find) return
    setVentasSelect(find.node.saleSet.edges)
    setIsPostpay(
      find.node.postpaidSales || Boolean(Number(user?.tokenAuth?.settings?.DISPATCH_WITHOUT_SALES))
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectOneClient, allClientsData])

  useEffect(() => {
    if (!idVentaSelect || ventasSelect.length === 0) {
      if (isPostpay) {
        setProductsSelect(productsOnlyPos)
      } else {
        setProductsSelect([])
      }
      return
    }
    const find = ventasSelect.find(({node}) => node.id === idVentaSelect)
    if (!find) return
    const dispachets = find.node.dispatchSet.edges
    const totDispachesStoreCloud =
      dipatchesStore.filter(({sale}) => sale === parseId(idVentaSelect)).length + dispachets.length
    setTotDispatches(totDispachesStoreCloud)
    const productsFilter = find.node.saleproductthroughSet.edges.map(({node}) => {
      const productId = node.product.id

      let dispachetsProduct = 0
      dispachets.forEach(({node: nodeDispatches}) => {
        const filtered = nodeDispatches.dispatchproductthroughSet.edges.filter(
          ({node: nodeDispatchesTrhou}) => {
            return nodeDispatchesTrhou.product.id === productId
          }
        )
        filtered.forEach(({node: nodeFiltered}) => {
          dispachetsProduct += Number(nodeFiltered.quantityDispatch)
        })
      })
      let dispatchesInStore = 0
      const productStoreFilter = dipatchesStore.filter(({products}) => {
        // return parseId(productId) === parseId(product.split('***')[0])
        return products.some((pro) => parseId(pro.product.split('***')[0]) === parseId(productId))
      })
      productStoreFilter.forEach(({products}) => {
        let tot = 0
        products.forEach((pro) => {
          tot += Number(pro.quantityDispatch)
        })
        dispatchesInStore += Number(tot)
      })
      return {
        node: {...node, units: Number(node.units) - dispachetsProduct - dispatchesInStore},
      }
    })
    console.log('productsFilter', productsFilter)
    setProductsSelect(productsFilter)
  }, [dipatchesStore, idVentaSelect, isPostpay, productsOnlyPos, ventasSelect])

  useEffect(() => {
    if (!volcoSizeAllowed || !formik.values.quantityDispatch || !formik.values.product) return
    if (Number(formik.values.quantityDispatch) > Number(volcoSizeAllowed)) {
      setErrorQuatity('No puede superear la capacidad máxima de: ' + volcoSizeAllowed)
      return
    }
    const find = productsSelect.find(({node}) => {
      return node.product.id === formik.values.product.split('***')[0]
    })
    if (!find) {
      setErrorQuatity(null)
      return
    }
    if (Number(formik.values.quantityDispatch) > Number(find.node.units)) {
      setErrorQuatity('No puede superear la cantidad máxima del producto: ' + find.node.units)
    } else {
      setErrorQuatity(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.quantityDispatch, volcoSizeAllowed, productsSelect, formik.values.product])

  console.log('isPostpay', isPostpay)

  return (
    <div>
      {(loadingClients || loadingVolcos) && (
        <div
          className='d-flex flex-center'
          style={{position: 'fixed', zIndex: 999, inset: 0, backgroundColor: '#000000cc'}}
        >
          <div className='d-flex flex-column flex-center'>
            <h4 className='text-white'>Descargando información...</h4>
            <Spinner size={50} color='light' />
          </div>
        </div>
      )}
      <BreadcrumbJeisat
        title='Agregar despacho'
        breadcrumb={[
          {
            title: 'Despachos',
            path: '/despachos',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
        isBtns
        children={
          <div className='d-flex align-items center gap-1'>
            {dateStorage && (
              <>
                <p className='p-0 m-0'>Ultima actualización - {moment(dateStorage).fromNow()}</p>
                <button
                  className='border-0 p-0 m-0 bg-transparent'
                  onClick={() => {
                    localStorage.setItem(STORAGE_NAMES.DATE, new Date().toISOString())

                    setDataLoad(0)
                    gqlGetClients({
                      variables: {
                        statusSale: 'ABIERTA',
                      },
                      fetchPolicy: 'network-only',
                    })
                    gqlGetCanteras({fetchPolicy: 'network-only'})
                    gqlGetNamtrikForm({
                      variables: {
                        codename: 'CLIENTE',
                      },
                      fetchPolicy: 'network-only',
                    })
                    gqlGetVolcos({variables: {after: null}, fetchPolicy: 'no-cache'})
                  }}
                  disabled={loadingCanteras || loadingClients || loadingNamtrikForm}
                >
                  <i
                    className={`fa fa-solid fa-rotate-right ${
                      loadingCanteras || loadingClients || loadingVolcos || loadingProducts
                        ? 'loading-refetch'
                        : ''
                    }`}
                  />
                </button>
              </>
            )}
          </div>
        }
      />
      <KTCard>
        <form
          className='w-100'
          onSubmit={(e) => {
            e.preventDefault()
            if (errorQuatity) return
            const values = Object.fromEntries(new FormData(e.currentTarget))
            const arrayFinal = getFormParse(
              values as unknown as {
                [key: string]: string
              }
            )
            console.log('arrayFinal', arrayFinal)
            if (arrayFinal.length > 0) {
              setFormDynamicValues(arrayFinal)
            }
            console.log('values DESDE AFUERA', values)
            formik.handleSubmit(e)
          }}
        >
          <KTCardBody className='py-4 d-flex w-100 align-items-center justify-content-center h-100'>
            <Row className='mt-2 w-100'>
              <Col lg='12' className='mb-4'>
                <div className='d-flex w-100 align-items-center gap-2'>
                  <h2>Complete los campos para agregar un despacho</h2>
                  {(loadingCanteras || loadingClients || loadingNamtrikForm || loadingVolcos) && (
                    <Spinner size='14px' />
                  )}
                </div>
              </Col>
              <Col lg='12' className='mb-4'>
                <Form.Group controlId='client'>
                  <Form.Label>Seleccione cliente</Form.Label>
                  <Select
                    value={selectOneClient}
                    onChange={(e) => {
                      formik.resetForm()
                      setIdVentaSelect('')
                      setSelectOneClient(e)
                      setFormDynamicValues(null)
                      formik.setFieldValue('client', e ? e.value : '')
                      setProductsToSend([])
                    }}
                    isClearable
                    options={clientSelects}
                    placeholder='Seleccione un cliente'
                    noOptionsMessage={() => 'No hay clientes'}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.client}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <div className='mb-4 w-100'>
                <Collapse
                  in={Boolean(selectOneClient && ventasSelect.length > 0)}
                  className='w-100'
                >
                  <div>
                    <h3 className='text-center'>Ventas de {selectOneClient?.label}</h3>
                    <Row className='my-4 align-items-center'>
                      <Col
                        lg={3}
                        className='d-flex align-items-center justify-content-center fw-bold text-uppercase'
                      >
                        Filtrar
                      </Col>
                      <Col lg={3}>
                        <Form.Control
                          placeholder='ID venta'
                          value={filterId}
                          onChange={(e) => {
                            setFilterId(e.target.value)
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <InputCurrency
                          placeholder='Precio'
                          onValueChange={(value) => {
                            if (!value) return setFilterPrice('')
                            setFilterPrice(value)
                          }}
                          value={filterPrice}
                        />
                      </Col>
                      <Col lg={3}>
                        <Form.Control
                          type='date'
                          placeholder='Precio'
                          value={filterDate}
                          onChange={(e) => {
                            setFilterDate(e.target.value)
                          }}
                        />
                      </Col>
                    </Row>

                    <div style={{overflow: 'hidden', margin: '0 auto'}}>
                      <div
                        className='w-100 d-flex gap-2'
                        style={{
                          overflowX: 'auto',
                          padding: '0 20px',
                        }}
                      >
                        {ventasSelect
                          .filter(({node}) => {
                            if (!filterId) return true
                            return parseId(node.id) === Number(filterId)
                          })
                          .filter(({node}) => {
                            if (!filterPrice || Number(filterPrice) < 1000) return true
                            return Number(node.saleTotal) <= Number(filterPrice)
                          })
                          .filter(
                            ({node}) =>
                              new Date(new Date(node.created).toISOString().split('T')[0]).setHours(
                                0,
                                0,
                                0,
                                0
                              ) <= new Date(filterDate).setHours(0, 0, 0, 0)
                          )
                          .map(({node: nodeVenta}) => (
                            <Card
                              key={nodeVenta.id}
                              border='dark'
                              style={{maxWidth: '20rem', fontSize: '0.9em', minWidth: '226px'}}
                            >
                              <Card.Header
                                className='ribbon ribbon-top ribbon-vertical'
                                style={{minHeight: '50px'}}
                              >
                                <Card.Title style={{lineHeight: 0.4}}>
                                  Venta: {parseId(nodeVenta.id)}
                                </Card.Title>
                                {nodeVenta.id === idVentaSelect && (
                                  <div className='ribbon-label bg-info'>
                                    <i className='bi bi-check-circle-fill text-light' />
                                  </div>
                                )}
                              </Card.Header>
                              <Card.Body style={{padding: '1em 2em'}}>
                                <Table>
                                  <tbody>
                                    <tr>
                                      <th>Valor total:</th>
                                      <td>{parsePrice(nodeVenta.saleTotal)}</td>
                                    </tr>
                                    <tr>
                                      <th>Productos:</th>
                                      <td>{nodeVenta.saleproductthroughSet.edges.length}</td>
                                    </tr>
                                    <tr>
                                      <th>Creada:</th>
                                      <td>
                                        {moment(nodeVenta.created).format('DD MMM [del] YYYY')}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                                <div className='d-flex align-items-center justify-content-center w-100'>
                                  {nodeVenta.id === idVentaSelect ? (
                                    <Button
                                      variant='warning'
                                      onClick={() => {
                                        setIdVentaSelect('')
                                        formik.setFieldValue('product', '')
                                        formik.setFieldValue('quantityDispatch', '')
                                      }}
                                    >
                                      Quitar
                                    </Button>
                                  ) : (
                                    <Button
                                      variant='success'
                                      onClick={() => {
                                        setIdVentaSelect(nodeVenta.id)
                                        formik.setFieldValue('product', '')
                                        setProductsToSend([])
                                      }}
                                    >
                                      Seleccionar
                                    </Button>
                                  )}
                                </div>
                              </Card.Body>
                            </Card>
                          ))}
                        {ventasSelect
                          .filter(({node}) => {
                            if (!filterId) return true
                            return parseId(node.id) === Number(filterId)
                          })
                          .filter(({node}) => {
                            if (!filterPrice || Number(filterPrice) < 1000) return true
                            return Number(node.saleTotal) < Number(filterPrice)
                          })
                          .filter(
                            ({node}) =>
                              new Date(new Date(node.created).toISOString().split('T')[0]).setHours(
                                0,
                                0,
                                0,
                                0
                              ) <= new Date(filterDate).setHours(0, 0, 0, 0)
                          ).length === 0 && (
                          <Card
                            border='dark'
                            style={{
                              maxWidth: '20rem',
                              fontSize: '0.9em',
                              margin: '0 auto',
                              height: '258px',
                            }}
                          >
                            <Card.Header
                              className='ribbon ribbon-top ribbon-vertical'
                              style={{minHeight: '50px'}}
                            >
                              <Card.Title>No se encontró resultado</Card.Title>
                            </Card.Header>
                            <Card.Body
                              style={{padding: '1em 2em'}}
                              className='d-flex align-items-center justify-content-center'
                            >
                              <Card.Text>Intenta con otra opción</Card.Text>
                            </Card.Body>
                          </Card>
                        )}
                      </div>
                    </div>
                  </div>
                </Collapse>
              </div>

              <Col lg='6' className='mb-4'>
                <Form.Group controlId='quarry'>
                  <Form.Label>Seleccione cantera</Form.Label>
                  <Form.Select
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.quarry}
                    isInvalid={formik.touched.quarry && !!formik.errors.quarry}
                  >
                    <option value=''>Seleccione una opción</option>
                    {canterasSelect.map(({label, value}) => (
                      <option value={value} key={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.quarry}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg='6' className='mb-4'>
                <Form.Group controlId='plate'>
                  <Form.Label>PLACA</Form.Label>
                  <Select
                    key={keySelectPlaque}
                    placeholder='Escriba la placa'
                    isClearable
                    options={volcosSelect}
                    onBlur={() => {
                      formik.setFieldTouched('plate', true)
                    }}
                    onChange={(e) => {
                      formik.setFieldValue('quantityDispatch', '')
                      if (!e) {
                        formik.setFieldValue('plate', '')
                        setVolcoSizeAllowed(null)
                        return
                      }
                      formik.setFieldValue('plate', e.value)
                      setVolcoSizeAllowed(e.size)
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        padding: '2px 0',
                        borderColor: state.isFocused
                          ? 'blue'
                          : formik.touched.plate && !!formik.errors.plate
                          ? '#f1416c'
                          : '#dbdfe9',
                      }),
                    }}
                  />
                  {formik.touched.plate && !!formik.errors.plate && (
                    <div
                      style={{
                        width: ' 100%',
                        marginTop: ' 0.5rem',
                        fontSize: '0.95rem',
                        color: '#f1416c',
                      }}
                    >
                      {formik.errors.plate}
                    </div>
                  )}
                  {/* <Form.Control
                    placeholder='Ingrese placa'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.plate}
                    isInvalid={formik.touched.plate && !!formik.errors.plate}
                  /> */}
                </Form.Group>
              </Col>

              <Col lg='6' className='mb-4'>
                <Form.Group controlId='departureTime'>
                  <Form.Label>Hora de salida</Form.Label>
                  <Form.Control
                    type='datetime-local'
                    placeholder='Ingrese hora de salida'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.departureTime}
                    isInvalid={formik.touched.departureTime && !!formik.errors.departureTime}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.departureTime}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg='6' className='mb-4'>
                <Form.Group controlId='saleType'>
                  <Form.Label>¿Usar transporte o envío?</Form.Label>
                  <Form.Select
                    onChange={(e) => setIsTransport(Boolean(e.target.value))}
                    /* value={formik.values.saleType}
                    isInvalid={formik.touched.saleType && !!formik.errors.saleType} */
                  >
                    <option value=''>NO</option>
                    <option value='SI'>SI</option>
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {/* {formik.errors.saleType} */}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Collapse in={isTransport}>
                <Row>
                  <Col lg={12} className='my-2'>
                    <Form.Label>Responsable</Form.Label>
                    <Form.Control
                      placeholder='Ingrese el nombre'
                      onChange={(e) => {
                        formik.setFieldValue('delivery', {
                          ...formik.values.delivery,
                          responsible: e.target.value,
                        })
                      }}
                      value={formik.values.delivery.responsible}
                      required={isTransport}
                    />
                  </Col>

                  <Col lg={6} className='my-2'>
                    <Form.Label>Total recorrido</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type='number'
                        placeholder='Ingrese total'
                        onChange={(e) => {
                          formik.setFieldValue('delivery', {
                            ...formik.values.delivery,
                            totalTravel: e.target.value,
                          })
                        }}
                        value={formik.values.delivery.totalTravel}
                        required={isTransport}
                      />
                      <InputGroup.Text>Km</InputGroup.Text>
                    </InputGroup>
                  </Col>
                  <Col lg={6} className='my-2'>
                    <Form.Label>Fecha</Form.Label>
                    <Form.Control
                      type='date'
                      placeholder='Ingrese fecha'
                      onChange={(e) => {
                        formik.setFieldValue('delivery', {
                          ...formik.values.delivery,
                          date: e.target.value,
                        })
                      }}
                      value={formik.values.delivery.date}
                      required={isTransport}
                    />
                  </Col>

                  <Col lg={6} className='my-2'>
                    <Form.Label>Desde</Form.Label>
                    <Form.Control
                      placeholder='Ingrese lugar de salida'
                      onChange={(e) => {
                        formik.setFieldValue('delivery', {
                          ...formik.values.delivery,
                          fromLocation: e.target.value,
                        })
                      }}
                      value={formik.values.delivery.fromLocation}
                      required={isTransport}
                    />
                  </Col>
                  <Col lg={6} className='my-2'>
                    <Form.Label>Hasta</Form.Label>
                    <Form.Control
                      placeholder='Ingrese lugar de llegada'
                      onChange={(e) => {
                        formik.setFieldValue('delivery', {
                          ...formik.values.delivery,
                          untilLocation: e.target.value,
                        })
                      }}
                      value={formik.values.delivery.untilLocation}
                      required={isTransport}
                    />
                  </Col>
                </Row>
              </Collapse>

              <Col lg='12' className='py-4'>
                <h2 className='text-center my-4'>Agregar producto</h2>
              </Col>

              <Col lg='5' className='mb-4'>
                <Form.Group controlId='product'>
                  <Form.Label>Seleccione un producto</Form.Label>
                  <Form.Select
                    onChange={formik.handleChange}
                    value={formik.values.product}
                    isInvalid={formik.touched.product && !!formik.errors.product}
                    onBlur={formik.handleBlur}
                  >
                    <option value=''>Seleccione producto</option>
                    {productsSelect.map(({node}) => (
                      <option
                        key={node.id}
                        value={`${node.product.id}***${node.product.unitType} ${node.product.name}`}
                        disabled={productsToSend.some(
                          (pro) => pro.product.split('***')[0] === node.product.id
                        )}
                      >
                        {node.units === Infinity ? '∞' : node.units} {node.product.unitType} de{' '}
                        {node.product.name}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.product}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg='5' className='mb-4'>
                <Form.Group controlId='quantityDispatch'>
                  <Form.Label>Cantidad despachada</Form.Label>
                  <Form.Control
                    type='number'
                    disabled={!Boolean(volcoSizeAllowed)}
                    placeholder='Ingrese cantidad a despachar'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.quantityDispatch}
                    isInvalid={
                      (formik.touched.quantityDispatch && !!formik.errors.quantityDispatch) ||
                      Boolean(errorQuatity)
                    }
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.quantityDispatch ? formik.errors.quantityDispatch : errorQuatity}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col
                lg='2'
                className={`mb-4 d-flex ${
                  (formik.errors.product && formik.touched.product) ||
                  (formik.errors.quantityDispatch && formik.touched.quantityDispatch) ||
                  errorQuatity
                    ? 'align-items-center'
                    : 'align-items-end'
                }`}
              >
                <Button
                  type='button'
                  disabled={Boolean(
                    !formik.values.product ||
                      !formik.values.quantityDispatch ||
                      formik.errors.quantityDispatch ||
                      errorQuatity
                  )}
                  onClick={() => {
                    if (!formik.values.product || !formik.values.quantityDispatch) return
                    const find = productsToSend.find((pre) => pre.product === formik.values.product)
                    if (find) return
                    if (!volcoSizeAllowed) return
                    let tot = 0
                    productsToSend.forEach((pro) => {
                      tot += Number(pro.quantity)
                    })
                    tot += Number(formik.values.quantityDispatch)
                    if (tot > Number(volcoSizeAllowed)) {
                      toast.warning('Supera el máximo del volco')
                      return
                    }
                    setProductsToSend((p) => [
                      ...p,
                      {
                        product: formik.values.product,
                        quantity: formik.values.quantityDispatch,
                      },
                    ])
                    formik.setFieldValue('product', '')
                    formik.setFieldValue('quantityDispatch', '')
                    formik.setFieldTouched('product', false)
                    formik.setFieldTouched('quantityDispatch', false)
                  }}
                >
                  Agregar
                </Button>
              </Col>

              <Col lg='12'>
                {productsToSend.length === 0 && (
                  <Alert>Debes seleccionar al menos un producto</Alert>
                )}
                <div
                  className='d-flex align-items-center gap-3'
                  style={{overflowX: 'auto', whiteSpace: 'nowrap'}}
                >
                  {productsToSend.map((pro) => (
                    <div
                      key={pro.product}
                      className='btn btn-outline d-flex align-items-center justify-content-between gap-3'
                      style={{cursor: 'inherit'}}
                    >
                      <span className='fw-bold mr-2'>{pro.quantity} </span>
                      <span>{pro.product.split('***')[1]}</span>
                      <button
                        type='button'
                        style={{
                          border: '0',
                          backgroundColor: '#ff7575',
                          borderRadius: '50%',
                          padding: '2px',
                        }}
                        className='d-flex flex-center'
                        onClick={() => {
                          setProductsToSend((pre) => {
                            const newArr = [...pre]
                            return newArr.filter((pre) => pre.product !== pro.product)
                          })
                        }}
                      >
                        <i className='bi bi-x fs-1 text-white' />
                      </button>
                    </div>
                  ))}
                </div>
              </Col>

              {productsToSend.length > 0 && (
                <Col lg='12'>
                  <Form.Label>
                    Total producto:{' '}
                    {productsToSend.reduce((sum, current) => {
                      return sum + Number(current.quantity)
                    }, 0)}
                  </Form.Label>
                </Col>
              )}

              <Col lg='12' className='mb-4'>
                <Form.Group controlId='observations'>
                  <Form.Label>Observaciones</Form.Label>
                  <Form.Control
                    as='textarea'
                    rows={3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations}
                    isInvalid={formik.touched.observations && !!formik.errors.observations}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {formik.errors.observations}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              {errorProductsForm && (
                <Col lg={12}>
                  <Alert variant='warning'>{errorProductsForm}</Alert>
                </Col>
              )}
              {namtrikForm &&
                isPostpay &&
                !Boolean(Number(user?.tokenAuth.settings.DISPATCH_WITHOUT_SALES)) && (
                  <NamtrikForm namtrikForm={namtrikForm} />
                )}

              {Boolean(Number(user?.tokenAuth.settings.DISPATCH_WITHOUT_SALES)) &&
              productsToSend.length > 0 &&
              // formik.values.quantityDispatch &&
              !idVentaSelect &&
              selectOneClient ? (
                <Col lg={12}>
                  <AlertDispatchNoSales
                    products={productsToSend}
                    // quantity={formik.values.quantityDispatch}
                    clientData={allClientsData}
                    client={selectOneClient}
                    allProducts={productsOnlyPos}
                  />
                </Col>
              ) : null}
            </Row>
          </KTCardBody>
          <Card.Footer>
            <div className='w-100 d-flex align-items-center justify-content-end'>
              <Button
                type='submit'
                disabled={
                  Boolean(!selectOneClient) ||
                  loadingCreate ||
                  !!errorQuatity ||
                  loadingRefetch ||
                  productsToSend.length === 0
                }
                className='d-flex align-items-center gap-1'
              >
                {(loadingCreate || loadingRefetch) && <Spinner size='16px' color='light' />}
                Agregar despacho
              </Button>
            </div>
          </Card.Footer>
        </form>
      </KTCard>
    </div>
  )
}
